<template>
  <div class="report_static_metric_cards">
    <woot-report-stats-card
      v-for="(metric, index) in metrics"
      :key="metric.NAME"
      :desc="metric.DESC"
      :heading="metric.NAME"
      :index="index"
      :on-click="changeSelection"
      :point="points[metric.KEY]"
      :selected="index === selectedIndex"
    />
  </div>
</template>

<script>
export default {
  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
    points: {
      type: Object,
      default: () => ({}),
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeSelection(index) {
      this.$emit('onClick', index);
    },
  },
};
</script>

<style>
.report_static_metric_cards {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.report_static_metric_cards .report-card {
  flex: auto;
  border: 1px solid var(--s-75);
  border-radius: var(--border-radius-normal);
  min-width: 170px;
}
.report_static_metric_cards .report-card.active {
  border-color: #6f1ddf;
}
</style>
